import { ApolloError, useQuery } from '@apollo/client'
import { MY_PRIVATE_PROFILE } from './Queries'
import { MyPrivateProfileQuery, MyPrivateProfileQueryVariables } from '../../types'

export default (
  employeeId: number,
): {
  data: MyPrivateProfileQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<MyPrivateProfileQuery, MyPrivateProfileQueryVariables>(MY_PRIVATE_PROFILE, {
    variables: {
      id: employeeId,
    },
  })

  return { data, error, loading }
}
